import { render, staticRenderFns } from "./ListOfService.vue?vue&type=template&id=5b1de40c&scoped=true"
import script from "./ListOfService.vue?vue&type=script&lang=js"
export * from "./ListOfService.vue?vue&type=script&lang=js"
import style0 from "./ListOfService.vue?vue&type=style&index=0&id=5b1de40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1de40c",
  null
  
)

export default component.exports